// extracted by mini-css-extract-plugin
module.exports = {"root":"EditVirtualAmenitiesPanel_root__1iibh","form":"EditVirtualAmenitiesPanel_form__29dK7","title":"EditVirtualAmenitiesPanel_title__1ltB2"};